/**
 * Centralized React Query key factory for cross-posting hooks.
 *
 * Every query hook and every invalidation call goes through this object so
 * "what key does this hook write" and "what key does the mutation invalidate"
 * cannot drift. Flat tuples (not deeply hierarchical) with `as const` for
 * literal-type inference on `queryKey` / `predicate` callers.
 *
 * Implements CONTEXT.md D-01 + D-02.
 *
 * Signature deviations from CONTEXT.md domain text, resolved per PATTERNS.md:
 *   - crossPostHistory takes `pageSize` (not `perPage`) and `page` is
 *     zero-indexed (server clamps `Math.max(0, …)` — posts/route.ts lines 223-233).
 */
export const crossPostingQueryKeys = {
  socialProfile: (comedianId: string) => ["socialProfile", comedianId] as const,

  crossPostHistory: (comedianId: string, page: number, pageSize: number) =>
    ["crossPostHistory", comedianId, page, pageSize] as const,

  crossPost: (id: string) => ["crossPost", id] as const,

  // Plan 05-06 (HIST-04 / D-19): per-post analytics, lazy-loaded via refetch()
  // (hook is enabled: false). staleTime 2min on the hook prevents back-to-back
  // re-clicks from re-hitting Ayrshare.
  crossPostAnalytics: (postId: string) =>
    ["crossPostAnalytics", postId] as const,
} as const;
